import React from 'react'
import { Modal, ModalTitle } from 'react-bootstrap'
import ContentStack from 'src/api/contentStack'
import { cartContainer } from 'src/models'
import parse from 'html-react-parser'
import { observable, reaction } from 'mobx'
import { observer } from 'mobx-react'
import './styles.scss'

@observer
class ShippingRates extends React.Component {
  @observable shippingRatesContent = ''
  hasRequestedShippingRates = false
  lastFetchedShippingCountry = null

  /** No `async` here: React's Component lifecycle typing expects a void return,
   *  not a Promise (Sonar/TS: void expected by extended type Component<any,any,any>). */
  componentDidMount() {
    this.getShippingRatesText()
    // Observe the cart address directly: mobx-react's observer skips
    // re-renders/lifecycle hooks when props are unchanged, so relying on
    // componentDidUpdate alone would miss address changes.
    this.disposeShippingCountryReaction = reaction(
      () => this.getShippingCountry(),
      (shippingCountry) => {
        if (shippingCountry !== this.lastFetchedShippingCountry) {
          this.getShippingRatesText().catch(error => {
            console.error('Failed to fetch shipping rates:', error)
          })
        }
      }
    )
  }

  componentWillUnmount() {
    this.disposeShippingCountryReaction?.()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.isInfoModalEnabled &&
      !prevProps.isInfoModalEnabled &&
      !this.hasRequestedShippingRates
    ) {
      this.getShippingRatesText()
    }
  }

  getShippingCountry = () =>
    cartContainer?.cartResponse?.deliveryDetails?.address?.country || ''

  getShippingRatesContent = (data = {}) => {
    return (
      data?.summary ||
      data?.shipping_rates ||
      data?.shippingRates ||
      data?.shipping_rates_summary ||
      data?.content ||
      data?.description ||
      ''
    )
  }

  getShippingRatesText = async () => {
    this.hasRequestedShippingRates = true
    const shippingCountry = this.getShippingCountry()
    this.lastFetchedShippingCountry = shippingCountry
    const data = await ContentStack.getShippingRatesFromContentStack({
      shippingCountry,
    })
    // Ignore stale responses: a newer address change may have superseded this one.
    if (shippingCountry !== this.lastFetchedShippingCountry) return
    this.shippingRatesContent = this.getShippingRatesContent(data)
  }

  render() {
    const { isInfoModalEnabled = false, toggleScanInfoModal = () => {} } =
      this.props

    return (
      <Modal
        centered={true}
        show={isInfoModalEnabled}
        className="subscription-dialog"
        dialogClassName="quick-view-dialog"
        onHide={toggleScanInfoModal}>
        <Modal.Header className="border-0" closeButton>
          <ModalTitle className="font-weight-bold d-flex m-0"></ModalTitle>
        </Modal.Header>
        <Modal.Body className="subscription-dialog-message">
          {this.shippingRatesContent && (
            <div
              className="shipping-rates contentstack-shipping-rates"
              data-testid="qa-contentstack-shipping-rates">
              {parse(this.shippingRatesContent)}
            </div>
          )}
        </Modal.Body>
      </Modal>
    )
  }
}

export default ShippingRates
